// src/components/VerifyEmail.js
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import api from '../../api/api';

import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import '../custom_styles.css';

function VerifyEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialEmail = location.state?.email || '';
  const [email, setEmail] = useState(initialEmail);
  const [code, setCode] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    setError(null);
    try {
      const res = await api.post('/auth/verify-email', { email, code });
      // const { access_token, user } = res.data;

      // store token and user like normal login
      // localStorage.setItem('access_token', access_token);
      // dispatch(setToken(access_token));
      // you may want a setUser action, or reuse login.fulfilled logic via a thunk
      setShow(true);
      setStatus('succeeded');
      navigate('/'); // Home page
    } catch (err) {
      setStatus('failed');
      setError(err.response?.data?.message || 'Verification failed');
    }
  };

  return (
    <Container className="py-5">
      <h1>Verify your email</h1>
      <p>We have sent a 6-digit code to your email. Enter it below to complete signup.</p>

      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            readOnly={!!initialEmail}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Verification code</Form.Label>
          <Form.Control
            type="text"
            value={code}
            onChange={e => setCode(e.target.value)}
            maxLength={6}
            required
          />
        </Form.Group>

        <Button type="submit" disabled={status === 'loading'}>
          {status === 'loading' ? 'Verifying...' : 'Verify'}
        </Button>
      </Form>
      <ToastContainer position="top-end" className="p-3">
          <Toast onClose={() => setShow(false)} show={show} delay={5000} autohide>
          <Toast.Header>
              <strong className="me-auto">Notification</strong>
              <small>Email Verification</small>
          </Toast.Header>
          <Toast.Body>Your Account will be activated in 6 hours.</Toast.Body>
          </Toast>
      </ToastContainer>
    </Container>
  );
}

export default VerifyEmail;
